namespace Matrix.Data {
    export interface SecurityMergeSourceForm {
        SourceCode: FormatLookupEditor;
        SelfMatch: Serenity.BooleanEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SecurityMergeSourceForm extends Serenity.PrefixedContext {
        static formKey = 'Data.SecurityMergeSource';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SecurityMergeSourceForm.init)  {
                SecurityMergeSourceForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = s.BooleanEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SecurityMergeSourceForm, [
                    'SourceCode', w0,
                    'SelfMatch', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
